import React from 'react';
import { TERMS } from '../../../utils/constants.js';
const TermsBox = () => {
 return (
   <p>
    {TERMS}
   </p>
 );
};

export default TermsBox;
